const SgiCollapseEO = function () {
    return {
        atvTab: '',
        ctlN: "折叠",
        ctlH: '100%',
        ctlW: '100%',
        desId: "EP_EO_UI_4104"
    }
}
export { SgiCollapseEO };
export default SgiCollapseEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiCollapseEO.js